<template>
  <div class="help">
    <h4>Quick help</h4>
    <tml-help-desk
      v-for="(help, key) in helpListItems"
      :key="key"
      class="title"
      :title="help.title"
    >
      <template v-if="help.title === 'Data privacy'">
        <p>
          Your data is secure. We store and use data consistent with our
          <tml-anchor target="_blank" href="/privacy-policy/">
            privacy policy
          </tml-anchor>
        </p>
      </template>
      <span v-else class="description" v-html="help.description" />
    </tml-help-desk>
    <tml-help-desk v-if="$store.state.subdomain?.policy" :title="policyTitle">
      <p>
        Data from this store collected by
        {{ $store.state.subdomain.divisionName }}
        will be processed according to the
        {{ $store.state.subdomain.divisionName }}
        <tml-anchor
          v-if="$store.state.subdomain.policy.policyUrl"
          target="_blank"
          :href="$store.state.subdomain.policy.policyUrl"
        >
          Privacy Policy
        </tml-anchor>
        {{
          $store.state.subdomain.policy.policyUrl &&
          $store.state.subdomain.policy.termsUrl
            ? '&'
            : ''
        }}
        {{ $store.state.subdomain.policy.termsUrl ? '' : '.' }}
        <tml-anchor
          v-if="$store.state.subdomain.policy.termsUrl"
          target="_blank"
          :href="$store.state.subdomain.policy.termsUrl"
        >
          Terms.
        </tml-anchor>
      </p>
    </tml-help-desk>
  </div>
</template>

<script>
import {splitTests} from '@teemill/common/classes';
import {isEU, isRestOfWorld} from '@teemill/modules/store-front';
import {usePaymentProcessorStore} from '@teemill/common/vuex';

export default {
  name: 'Help',

  props: {
    hideReturnsPolicy: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const helpList = [
      {
        title: 'Secure checkout',
        description:
          'Our checkout is protected by 256-bit encrypted connection and we never store your card details',
      },
      {
        title: 'Organic quality',
        description:
          'We hope you’re blown away by the softness and quality of our organic cotton products :)',
      },
      {
        title: 'Data privacy',
      },
    ];

    if (
      usePaymentProcessorStore().getter('paymentProcessorType') !== 'direct'
    ) {
      helpList.unshift(
        isEU.passes || isRestOfWorld.passes
          ? {
              title: 'Returns',
              description: 'Hassle-free 28 day return policy',
            }
          : {
              title: 'Free returns',
              description:
                'Easy, and fast 28 day return policy. Free both ways in the UK',
            }
      );
    }
    return {helpList};
  },

  computed: {
    helpListItems() {
      let filteredHelpList = this.helpList;
      const kitlockerDivision = 356097;
      const proKitsDivision = 426542;

      if (this.$store.state.subdomain?.division === kitlockerDivision) {
        filteredHelpList.unshift({
          title: 'Product sizing',
          description:
            "We have taken care to provide a clear size guide with every product, please take care when selecting products (especially those with personalisation). We do accept returns & exchanges for blank product, but reserve the right to reject returns on personalised items. If you are unsure on sizing please don't hesitate to reach out, or order samples to size from ahead of placing a personalised order.",
        });
        filteredHelpList = this.helpList.filter(
          item => !['Organic quality'].includes(item.title)
        );
      } else if (this.$store.state.subdomain?.division === proKitsDivision) {
        filteredHelpList.unshift({
          title: 'Product sizing',
          description:
            'Sizes run true to size, but if you’re unsure please contact a member of the team before ordering. As all personalised items are made to order, once an order has been placed and production has begun we are unable to offer refunds or exchanges.',
        });
      } else {
        filteredHelpList.unshift({
          title: 'Normal sizing',
          description:
            'Sizes are normal, there’s no funny business. If you’re still unsure, exchanging sizes is easy if you want to go up or down a size',
        });
      }

      if (this.hideReturnsPolicy) {
        filteredHelpList = this.helpList.filter(
          item => !['Returns', 'Free returns'].includes(item.title)
        );
      }

      return filteredHelpList;
    },

    policyTitle() {
      const subdomain = this.$store.state.subdomain;
      const division = subdomain.divisionName || '';
      const policy = subdomain.policy;
      const hasPolicyUrl = Boolean(policy.policyUrl);
      const hasTermsUrl = Boolean(policy.termsUrl);

      if (hasPolicyUrl && hasTermsUrl) {
        return `${division} Policy & Terms`;
      }

      if (hasPolicyUrl) {
        return `${division} Policy`;
      }

      if (hasTermsUrl) {
        return `${division} Terms`;
      }

      return division;
    },
  },
};
</script>
